export default "__VITE_ASSET__CeIq1C9Q__"